export enum ProjectStatus {
  Project = 'Projet',
  PendingValidation = 'En attente de validation',
  Proposal = 'Proposition',
  Accepted = 'Accepté par le client',
  Signed = 'Signé',
  Finished = 'Terminé'
}
